export enum AddressBookAddressType {
    AddressBook = "AddressBook",
}
